var _path, _g, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithHummingbird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 55,
    viewBox: "0 0 108 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_1184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2154_1184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0776 0H0V35.0647H42.0776V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2154_1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.23492C6.25945 1.01381 12.9369 4.94486 15.6327 6.53051C15.9665 6.72679 19.2989 8.95003 23.5025 9.96016C26.3129 10.6358 29.5123 10.7687 32.4649 9.392C31.5773 15.1631 26.3808 19.7611 19.0945 17.0525C14.7685 15.4441 13.7997 11.1185 10.7106 8.36985C5.42778 3.67034 2.41793 2.78839 0 2.23492Z",
    fill: "url(#paint0_linear_2154_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.633 6.52989C14.0015 4.2172 11.8127 2.0694 7.90332 0.0885215C15.725 -0.107096 20.0375 3.852 24.4328 6.66543C24.3366 8.21168 23.9469 9.11766 23.5028 9.95955C19.2999 8.94942 15.9668 6.72618 15.633 6.52989Z",
    fill: "url(#paint1_linear_2154_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9621 2.24154C31.9092 3.18158 32.2621 7.67145 32.4643 9.39128C29.5118 10.768 26.3124 10.6351 23.502 9.95944C23.9461 9.11755 24.3358 8.21157 24.4319 6.66532C24.6809 0.349458 31.1405 -0.262098 33.1595 2.57002C33.3859 2.94492 34.7337 2.71865 36.4158 2.43626C38.1907 2.13831 40.3377 1.77787 41.9324 1.99519C42.0979 2.01321 42.1276 2.22752 41.9621 2.24154ZM31.6703 3.27497C31.6703 2.94249 31.3817 2.67009 31.0296 2.67009C30.6774 2.67009 30.3888 2.93982 30.3888 3.27497C30.3888 3.61013 30.6774 3.87985 31.0296 3.87985C31.3817 3.87985 31.6703 3.60746 31.6703 3.27497Z",
    fill: "url(#paint2_linear_2154_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4644 9.39136C31.5769 15.1624 26.3803 19.7604 19.094 17.0518C16.3105 20.1657 14.7051 23.134 13.8848 25.8486C15.1535 22.3863 20.6089 22.0812 25.0989 20.5269C30.7996 18.5534 33.2692 14.7792 32.4644 9.39136Z",
    fill: "url(#paint3_linear_2154_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0992 20.5269C19.9692 23.3176 16.081 25.6697 13.7161 34.3042C13.6376 34.7429 13.2352 35.0673 12.7656 35.0647C12.9198 32.9282 12.726 29.6815 13.8844 25.8486C15.1531 22.3862 20.6092 22.0811 25.0992 20.5269Z",
    fill: "url(#paint4_linear_2154_1184)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4278 35.6705L65.678 34.9312C64.4283 34.7048 63.462 34.1382 63.462 32.9435C63.462 31.4648 64.8827 31.0256 66.5294 31.0256H74.1691C74.5299 31.0256 74.8223 30.7326 74.8223 30.371V24.7708C74.8217 24.4092 74.5293 24.1162 74.1684 24.1162H66.5288C59.831 24.1162 55.5654 28.3264 55.5654 33.5075C55.5654 37.4939 57.95 40.9066 63.9713 42.2171L67.2092 42.9564C69.3103 43.4117 69.9926 44.0411 69.9926 45.065C69.9926 46.3173 68.9133 47.0896 66.6973 47.0909H58.6968C58.3411 47.0909 58.0526 47.38 58.0526 47.7364V53.455C58.0526 53.8114 58.3411 54.1006 58.6968 54.1006H66.6973V54.1109C74.7029 54.1109 78.1196 49.3878 78.1196 44.5489C78.1196 40.3936 75.2787 36.8652 69.4278 35.6705Z",
    fill: "#040742"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0381 52.906V39.1194C21.0381 31.0226 27.6202 24.4597 35.7406 24.4597H41.6896C42.2284 24.4597 42.6622 24.8949 42.6622 25.4295V32.3577C42.6622 32.895 42.2257 33.3275 41.6896 33.3275H35.7406C32.5345 33.3275 29.9345 35.9199 29.9345 39.1167V52.9033C29.9345 53.4406 29.498 53.8731 28.9619 53.8731H22.0134C21.4746 53.8731 21.0408 53.4379 21.0408 52.9033L21.0381 52.906Z",
    fill: "#040742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6237 24.4583H45.6017C45.0687 24.4583 44.6367 24.8958 44.6367 25.4356V53.1268C44.6367 53.6666 45.0687 54.1042 45.6017 54.1042H52.6237C53.1566 54.1042 53.5886 53.6666 53.5886 53.1268V25.4356C53.5886 24.8958 53.1566 24.4583 52.6237 24.4583Z",
    fill: "#040742"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.997 38.4685C107.997 29.2925 102.531 23.8442 93.6702 23.8442C86.248 23.8442 79.4004 29.6934 79.4004 38.872C79.4004 48.0505 86.4204 54.0715 94.3048 54.0715C95.2675 54.0715 100.226 54.0669 100.226 54.0669C101.057 54.0669 101.746 53.5157 101.746 52.5511V47.8656C101.746 47.0388 101.057 46.6708 100.23 46.6708C98.7143 46.6708 96.1703 46.6708 94.4197 46.6708C91.419 46.6708 88.7786 44.8799 88.0866 42.2456C87.9429 41.6989 88.3477 41.1627 88.9118 41.1627H106.412C107.237 41.1627 107.924 40.5197 107.966 39.6997C107.987 39.3093 108 38.8824 108 38.4685H107.997ZM89.139 35.5426C88.5514 35.5426 88.1388 34.9673 88.3268 34.4154C88.9484 32.575 90.7347 30.7268 93.7851 30.7268C97.2559 30.7268 98.8672 32.5776 99.3687 34.4597C99.5149 35.0063 99.1101 35.5452 98.5434 35.5452H89.139V35.5426Z",
    fill: "#040742"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2154_1184",
    x1: 7.03596,
    y1: 9.92611,
    x2: 30.501,
    y2: 9.92611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2154_1184",
    x1: 7.90332,
    y1: 5.02103,
    x2: 24.4328,
    y2: 5.02103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2154_1184",
    x1: 23.502,
    y1: 5.70458,
    x2: 42.0724,
    y2: 5.70458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2154_1184",
    x1: 13.8848,
    y1: 17.62,
    x2: 32.6129,
    y2: 17.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FF9B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2154_1184",
    x1: 18.9331,
    y1: 31.3506,
    x2: 18.9331,
    y2: 20.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_1184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithHummingbird);
export default __webpack_public_path__ + "static/media/logo-with-hummingbird.60879d3d5e3b3b6922979f2442fbf2c6.svg";
export { ForwardRef as ReactComponent };